import React, { useState, useEffect } from 'react'

//* Components
import CartHeaders from './components/CartHeaders/CartHeaders'
import CartRow from './components/CartRow/CartRow'
import CartActions from './components/CartActions/CartActions'
import CartTotals from './components/CartTotals/CartTotals'

//* Hooks
import useResponsiveJSX from 'hooks/useResponsiveJSX'

//* Styles
import styles from './CartTable.module.scss'

const CartTable = ({ cart, setCart, wcCart }) => {

    const [ cartItems, setCartItems ] = useState([])

    useEffect(() => {
      

        if(cart !== undefined && cart !== null) {

            const existing_cart_array = Object.values(cart)

            setCartItems(existing_cart_array)

        }

        /* eslint-disable-next-line */
    }, [cart])

    const bp = useResponsiveJSX()

    if( bp < 2){
        return (
            <div className={styles["cart-table"]}>
                {
                    cartItems.length === 0 ? null :
                    cartItems.map( item => {
                        return(
                            <CartRow
                                productId={item.id}
                                quantity={item.quantity}
                                key={`cart-item-${item.id}`}
                                cart={cart}
                                setCart={setCart}
                                wcCart={wcCart}
                            />
                        )
                    })
                }
                <CartTotals cart={cart}/>
                <CartActions />
            </div>
        )
    }
    

  return (
    <div className={styles["cart-table"]}>
        <CartHeaders/>
        {
            cartItems.length === 0 ? null :
            cartItems.map( item => {
                return(
                    <CartRow
                        productId={item.id}
                        quantity={item.quantity}
                        key={`cart-item-${item.id}`}
                        cart={cart}
                        setCart={setCart}
                        wcCart={wcCart}
                    />
                )
            })
        }
        <CartActions />
        <CartTotals cart={cart}/>
    </div>
  )
}

export default CartTable